function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTr2Tog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10.495144mm",
    height: "20.123152mm",
    viewBox: "0 0 10.495144 20.123152",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-89.898836,-104.72054)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 90.397187,124.35051 4.736091,-19.13678 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 99.895628,124.35051 95.159537,105.21373 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.999999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 90.620208,112.35193 h 9.052398 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.999999,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 90.620207,114.78108 h 9.0524 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr2Tog);
export default __webpack_public_path__ + "static/media/tr2tog.804a44f73663b7a606ca21055d60661c.svg";
export { ForwardRef as ReactComponent };